<template>
  <div>
    <video
      width="720"
      height="540"
      controls
    >
      <source :src="fullSource" type="video/mp4" />
    </video>
    <div
      v-for="(section, index) in notes"
      :key="index"
      class="noteDiv container text-left"
    >
      <h4 v-html="section.sectionHead" class="sectionHeader"></h4>
      <p v-for="(paragraph, idx2) in section.paragraphs" :key="idx2">
        <span v-html="paragraph"></span>
      </p>
    </div>
    <!-- <p>{{ notes }}</p> -->
  </div>
</template>
<script>
export default {
  name: 'LessonVideo',
  props: {
    videoSource: {
      type: String,
      required: true
    },
    notes: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  // data() {
  //   return {
  //     fullSource: 'https://sunday-school-videos.s3.amazonaws.com/' + videoSource
  //   }
  // },
  computed: {
    fullSource() {
      return this.videoSource ? 'https://sunday-school-videos.s3.amazonaws.com/' + this.videoSource : ''
    }
  }
}
</script>
